
export const OperationLogEnum = {
  dimension: {
    ASIN: 'Asin',
    VARIATION_ASIN: 'Variation'
  },
  dimensionOption: [
    {id: 'Asin', text: 'ASIN'},
    {id: 'Variation', text: '父ASIN'},
  ],
  typeOption: [
    {id: 0, color: '#afbacb'},
    {id: 1, color: '#223273'},
    {id: 2, color: '#34bfa3'},
    {id: 3, color: '#90c'},
    {id: 4, color: '#FFBF00'},
    {id: 5, color: '#5986FB'},
    {id: 6, color: '#cdb181'},
    {id: 7, color: '#bd666f'},
    {id: 8, color: '#83604a'},
    {id: 9, color: '#738AE6'},
  ]
};
